<template>
  <v-row v-if="row && form">
    <v-col
      v-if="row.title"
      cols="12"
    >
      <p>{{ row.title }}</p>
    </v-col>
    <v-col
      v-for="(field, field_index) in row.fields"
      :key="'field_'+ field_index"
      :cols="field.width"
      :xs="field.width_xs"
      :md="field.width_md"
    >
      <div v-if="!field.if_key || form[field.if_key] == field.if_value">
        <div v-if="field.level === 1">
          <v-text-field
            v-if="field.type === 0"
            v-model="form[field.key]"
            :label="field.title"
            outlined
            :hint="field.hint"
            :readonly="field.readonly"
          />
          <v-text-field
            v-else-if="field.type === 1"
            v-model="form[field.key]"
            :label="field.title"
            :hint="field.hint"
            outlined
            :default="field.default_value"
            type="number"
            :readonly="field.readonly"
          />
          <v-text-field
            v-else-if="field.type === 2"
            v-model="form[field.key]"
            :label="field.title"
            :hint="field.hint"
            outlined
            :default="field.default_value"
            type="date"
            :readonly="field.readonly"
          />
          <v-autocomplete
            v-else-if="field.type === 3"
            v-model="form[field.key]"
            :label="field.title"
            :hint="field.hint"
            :items="field.group ? field.select.filter(a=>a.group == form[field.group]) : field.select"
            clearable
            outlined
            :readonly="field.readonly"
          />
          <v-checkbox
            v-else-if="field.type === 4"
            v-model="form[field.key]"
            :label="field.title"
            :hint="field.hint"
            :readonly="field.readonly"
          />
          <uploadFiles
            v-else-if="field.type === 5"
            v-model="form[field.key]"
            :label="field.title"
            :hint="field.hint"
            :btn_text="'+ Загрузить фотографии'"
          />
          <uploadFiles
            v-else-if="field.type === 6"
            v-model="form[field.key]"
            :label="field.title"
            :hint="field.hint"
            :btn_text="'+ Загрузить фотографию'"
            :limit="1"
            :single="true"
          />
          <v-select
            v-else-if="field.type === 7"
            v-model="form[field.key]"
            :label="field.title"
            :hint="field.hint"
            :items="field.group ? field.select.filter(a=>a.group == form[field.group]) : field.select"
            clearable
            outlined
            :readonly="field.readonly"
            multiple
          />
          <div v-else-if="field.type === 8">
            <v-row>
              <v-col cols="12">
                {{ field.title }}
              </v-col>
            </v-row>
            <v-row
              v-for="(item, index) in form[field.key]"
              :key="'array'+index"
            >
              <v-col cols="10">
                <row
                  v-for="(row, row_index) in field.rows"
                  :key="'dfdf'+row_index"
                  :row="row"
                  :form="item"
                />
              </v-col>
              <v-col cols="2">
                <v-icon
                  large
                  class="mt-15"
                  @click="form[field.key] = form[field.key].filter(a=>a!=item)"
                >
                  mdi-minus-circle-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col
                cols="12"
                class="text-left"
                md="6"
              >
                <v-btn
                  text
                  color="primary"
                  @click="check_array(form, field.key), form[field.key].push({})"
                >
                  <v-icon
                    large
                    class="mr-2"
                    color="primary"
                  >
                    mdi-plus-circle-outline
                  </v-icon>
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-if="field.level === 2">
          <v-text-field
            v-if="field.type === 0"
            v-model="form[field.key1][field.key2]"
            :label="field.title"
            outlined
            :hint="field.hint"
            :readonly="field.readonly"
          />
          <v-text-field
            v-else-if="field.type === 1"
            v-model="form[field.key1][field.key2]"
            :label="field.title"
            :hint="field.hint"
            outlined
            :default="field.default_value"
            type="number"
            :readonly="field.readonly"
          />
          <v-text-field
            v-else-if="field.type === 2"
            v-model="form[field.key1][field.key2]"
            :label="field.title"
            :hint="field.hint"
            outlined
            :default="field.default_value"
            type="date"
            :readonly="field.readonly"
          />
          <v-select
            v-else-if="field.type === 3"
            v-model="form[field.key1][field.key2]"
            :label="field.title"
            :hint="field.hint"
            :items="field.group ? field.select.filter(a=>a.group == form[field.key1][field.group]) : field.select"
            clearable
            outlined
            :readonly="field.readonly"
          />
          <v-checkbox
            v-else-if="field.type === 4"
            v-model="form[field.key1][field.key2]"
            :label="field.title"
            :hint="field.hint"
            :readonly="field.readonly"
          />
          <uploadFiles
            v-else-if="field.type === 5"
            v-model="form[field.key1][field.key2]"
            :label="field.title"
            :hint="field.hint"
            :btn_text="'+ Загрузить'"
          />
          <uploadFiles
            v-else-if="field.type === 6"
            v-model="form[field.key1][field.key2]"
            :label="field.title"
            :hint="field.hint"
            :btn_text="'+ Загрузить'"
            :limit="1"
            :single="true"
          />
          <v-select
            v-else-if="field.type === 7"
            v-model="form[field.key1][field.key2]"
            :label="field.title"
            :hint="field.hint"
            :items="field.group ? field.select.filter(a=>a.group == form[field.key1][field.group]) : field.select"
            clearable
            outlined
            :readonly="field.readonly"
            multiple
          />
          <div v-else-if="field.type === 8">
            <v-row>
              <v-col cols="12">
                {{ field.title }}
              </v-col>
            </v-row>
            <v-row
              v-for="(item, index) in form[field.key1][field.key2]"
              :key="'array'+index"
            >
              <v-col cols="10">
                <row
                  v-for="(row, row_index) in field.rows"
                  :key="'dfdf'+row_index"
                  :row="row"
                  :form="item"
                />
              </v-col>
              <v-col cols="2">
                <v-icon
                  large
                  class="mt-15"
                  @click="form[field.key1][field.key2] = form[field.key1][field.key2].filter(a=>a!=item)"
                >
                  mdi-minus-circle-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col
                cols="12"
                class="text-left"
                md="6"
              >
                <v-btn
                  text
                  color="primary"
                  @click="form[field.key1][field.key2].push({})"
                >
                  <v-icon
                    large
                    class="mr-2"
                    color="primary"
                  >
                    mdi-plus-circle-outline
                  </v-icon>
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-if="field.level === 3">
          <v-text-field
            v-if="field.type === 0"
            v-model="form[field.key1][field.key2][field.key3]"
            :label="field.title"
            outlined
            :hint="field.hint"
            :readonly="field.readonly"
          />
          <v-text-field
            v-else-if="field.type === 1"
            v-model="form[field.key1][field.key2][field.key3]"
            :label="field.title"
            :hint="field.hint"
            outlined
            :default="field.default_value"
            type="number"
            :readonly="field.readonly"
          />
          <v-text-field
            v-else-if="field.type === 2"
            v-model="form[field.key1][field.key2][field.key3]"
            :label="field.title"
            :hint="field.hint"
            outlined
            :default="field.default_value"
            type="date"
            :readonly="field.readonly"
          />
          <v-select
            v-else-if="field.type === 3"
            v-model="form[field.key1][field.key2][field.key3]"
            :label="field.title"
            :hint="field.hint"
            :items="field.group ? field.select.filter(a=>a.group == form[field.key1][field.key2][field.group]) : field.select"
            clearable
            outlined
            :readonly="field.readonly"
          />
          <v-checkbox
            v-else-if="field.type === 4"
            v-model="form[field.key1][field.key2][field.key3]"
            :label="field.title"
            :hint="field.hint"
            :readonly="field.readonly"
          />
          <uploadFiles
            v-else-if="field.type === 5"
            v-model="form[field.key1][field.key2][field.key3]"
            :label="field.title"
            :hint="field.hint"
            :btn_text="'+ Загрузить фотографии'"
          />
          <uploadFiles
            v-else-if="field.type === 6"
            v-model="form[field.key1][field.key2][field.key3]"
            :label="field.title"
            :hint="field.hint"
            :btn_text="'+ Загрузить фотографию'"
            :limit="1"
            :single="true"
          />
          <v-select
            v-else-if="field.type === 7"
            v-model="form[field.key1][field.key2][field.key3]"
            :label="field.title"
            :hint="field.hint"
            :items="field.group ? field.select.filter(a=>a.group == form[field.key1][field.key2][field.group]) : field.select"
            clearable
            outlined
            :readonly="field.readonly"
            multiple
          />
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
    props: {
            row: {
                type: Object,
                default: null
            },
            form: {
                type: Object,
                default: null
        }
    },
    methods: {
        check_array: function (form, key) {
            form[key] = form[key] || []
        }
    }
}
</script>
